/* ============================================================
   Add-to-Cart price — shows the live variant total on the right side
   of the "Add to cart" button.

   The theme rewrites the button's innerHTML on every variant change
   (_updateAddToCartButton sets it to the plain "Add to cart" / "Sold out"
   / "Unavailable" string), which would wipe any price markup. So instead
   of relying on Liquid, we observe the button and re-inject the price
   after the theme rewrites it. The price is read from the theme's own
   `.price-list` (kept in the DOM and updated on every variant change,
   even though it's visually hidden), so it always stays in sync.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var btn = document.querySelector('.product-form__add-button');
    if (!btn) return;

    var priceSource = document.querySelector('.price-list');

    function currentPrice() {
      if (!priceSource) return '';
      var hl = priceSource.querySelector('.price--highlight');
      if (hl) return hl.textContent.trim();
      var p = priceSource.querySelector('.price:not(.price--compare)');
      return p ? p.textContent.trim() : '';
    }

    var btnObserver = new MutationObserver(render);

    function render() {
      // Only decorate the active "add to cart" state — leave Sold out /
      // Unavailable text untouched.
      var isAdd =
        btn.classList.contains('button--primary') &&
        btn.getAttribute('data-action') === 'add-to-cart';
      if (!isAdd) return;

      var price = currentPrice();
      var existing = btn.querySelector('[data-atc-price]');

      if (existing) {
        if (price && existing.textContent !== price) existing.textContent = price;
        return;
      }

      // The theme just (re)wrote a plain label; wrap it and append the price.
      var label = btn.innerHTML;
      btnObserver.disconnect();
      btn.classList.add('product-form__add-button--has-price');
      btn.innerHTML =
        '<span class="atc-text">' + label + '</span>' +
        (price ? '<span class="atc-price" data-atc-price>' + price + '</span>' : '');
      btnObserver.observe(btn, { childList: true, subtree: true, characterData: true });
    }

    btnObserver.observe(btn, { childList: true, subtree: true, characterData: true });

    // Keep the button price in step when only the price changes.
    if (priceSource) {
      new MutationObserver(function () {
        var span = btn.querySelector('[data-atc-price]');
        if (!span) return;
        var p = currentPrice();
        if (p && span.textContent !== p) span.textContent = p;
      }).observe(priceSource, { childList: true, subtree: true, characterData: true });
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
